// src/services/notificationService.js
import { pb } from "./pocketbase";

export const notificationService = {
  // --- 1. BUSCAR NOTIFICAÇÕES DO USUÁRIO OU OPERADOR ATIVO ---
  async getNotifications({ userId, operatorId, limit = 50 }) {
    if (!userId && !operatorId) return [];

    try {
      const filters = [];
      if (userId) {
        filters.push(`recipient_user = "${userId}"`);
      }
      if (operatorId) {
        filters.push(`recipient_operator = "${operatorId}"`);
      }

      const filterQuery = filters.join(" || ");
      const records = await pb.collection("notifications").getList(1, limit, {
        filter: filterQuery,
        sort: "-created",
        expand: "recipient_user,recipient_operator",
      });

      return records.items || [];
    } catch (error) {
      console.warn("⚠️ [notificationService] Erro ao buscar notificações:", error);
      return [];
    }
  },

  // --- 2. CONTAR NOTIFICAÇÕES NÃO LIDAS ---
  async getUnreadCount({ userId, operatorId }) {
    if (!userId && !operatorId) return 0;

    try {
      const filters = [];
      if (userId) {
        filters.push(`(recipient_user = "${userId}" && read = false)`);
      }
      if (operatorId) {
        filters.push(`(recipient_operator = "${operatorId}" && read = false)`);
      }

      const filterQuery = filters.join(" || ");
      const res = await pb.collection("notifications").getList(1, 1, {
        filter: filterQuery,
        fields: "id",
      });

      return res.totalItems || 0;
    } catch (error) {
      console.warn("⚠️ [notificationService] Erro ao contar não lidas:", error);
      return 0;
    }
  },

  // --- 3. CRIAR UMA NOTIFICAÇÃO ---
  async createNotification({
    recipient_user = null,
    recipient_operator = null,
    type = "mention",
    title,
    message,
    link_tab = null,
    link_id = null,
    link_message_id = null,
  }) {
    if (!recipient_user && !recipient_operator) return null;

    try {
      const payload = {
        title,
        message: message ? message.substring(0, 300) : "",
        type,
        link_tab,
        link_id: link_id ? String(link_id) : null,
        link_message_id: link_message_id ? String(link_message_id) : null,
        read: false,
      };

      if (recipient_user) payload.recipient_user = recipient_user;
      if (recipient_operator) payload.recipient_operator = recipient_operator;

      const record = await pb.collection("notifications").create(payload);
      return record;
    } catch (error) {
      console.error("❌ [notificationService] Erro ao criar notificação:", error);
      return null;
    }
  },

  // --- 4. MARCAR COMO LIDA ---
  async markAsRead(notificationId) {
    if (!notificationId) return;
    try {
      await pb.collection("notifications").update(notificationId, {
        read: true,
        read_at: new Date().toISOString(),
      });
      return true;
    } catch (error) {
      console.error("❌ [notificationService] Erro ao marcar como lida:", error);
      return false;
    }
  },

  // --- 5. MARCAR TODAS COMO LIDAS ---
  async markAllAsRead({ userId, operatorId }) {
    if (!userId && !operatorId) return false;

    try {
      const unreadList = await this.getNotifications({ userId, operatorId, limit: 100 });
      const pending = unreadList.filter(n => !n.read);

      await Promise.all(
        pending.map(n =>
          pb.collection("notifications").update(n.id, {
            read: true,
            read_at: new Date().toISOString(),
          }).catch(() => {})
        )
      );

      return true;
    } catch (error) {
      console.error("❌ [notificationService] Erro ao marcar todas como lidas:", error);
      return false;
    }
  },

  // --- 6. EXCLUIR NOTIFICAÇÃO ---
  async deleteNotification(notificationId) {
    if (!notificationId) return;
    try {
      await pb.collection("notifications").delete(notificationId);
      return true;
    } catch (error) {
      console.error("❌ [notificationService] Erro ao deletar notificação:", error);
      return false;
    }
  },
};
